import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AiOutlineSearch } from 'react-icons/ai';
import {
  Icon,
  Box,
  Flex,
  Button,
  Text,
  Input,
  Divider,
  AbsoluteCenter,
  Img,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { ReactComponent as LogoPintar } from '../../assets/svg/logo_pintar.svg';
import UserProfile from './UserProfile';
import { GetAuthData } from '../../../misc/GetAuthData';
import MenuBottomNavbar from './MobileBottomNavbar';

const NewNavbar: React.FC = () => {
  const history = useHistory();
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>('');

  const locationPage = window.location.pathname;

  const logoNavbar = localStorage.getItem('logoNavbar') ?? '';

  const searchPelatihan = (e) => {
    e.preventDefault();
    localStorage.setItem('keywordPelatihan', keyword);
    history.push('/pelatihan');
  };

  const handleNavigate = (path: string) => {
    history.push(path);
    window.scrollTo(0, 0);
  };

  const WrapperNavigate = ({
    path,
    matchPattern,
    isMenu = false,
    children,
  }) => {
    // Handle active state logic:
    // - If matchPattern is provided and is "/", use exact match (to avoid matching all routes)
    // - If matchPattern is an array, check if any pattern matches
    // - If matchPattern is a string (not "/"), use startsWith for sub-route matching
    // - Otherwise, fall back to exact path matching
    const isActive = matchPattern
      ? Array.isArray(matchPattern)
        ? matchPattern.some((pattern) =>
            pattern === '/'
              ? locationPage === '/'
              : locationPage.startsWith(pattern)
          )
        : matchPattern === '/'
        ? locationPage === '/'
        : locationPage.startsWith(matchPattern)
      : locationPage === path;

    return (
      <Box
        _hover={{ cursor: 'pointer' }}
        display="flex"
        onClick={() => handleNavigate(path)}
        alignItems="center"
      >
        {isMenu ? (
          <Text
            fontSize="md"
            display="inline-block"
            _after={{
              content: `''`,
              display: 'block',
              width: '0',
              background: 'green.700',
            }}
            _hover={{
              '::after': {
                width: '100%',
                transition: 'width',
                transitionDuration: '.2s',
              },
            }}
            color={isActive ? 'green.600' : 'gray.600'}
            fontWeight={isActive ? 'semibold' : 'normal'}
          >
            {children}
          </Text>
        ) : (
          <>{children}</>
        )}
      </Box>
    );
  };

  return (
    <>
      {/* large screen */}
      <Box bg="white" display={{ base: 'none', md: 'block' }}>
        <Flex
          justify="space-between"
          align="center"
          alignItems="center"
          h={20}
          px={{ base: 8, md: 12 }}
        >
          {/* Logo */}
          <Flex align="center">
            <WrapperNavigate path="/" matchPattern="/">
              <Img src={logoNavbar} height={10} />
            </WrapperNavigate>
          </Flex>
          <Flex align="center" alignItems="center" className="gap-4">
            {/* Navigation Link */}
            <Flex className="gap-5">
              <WrapperNavigate path="/" matchPattern="/" isMenu={true}>
                Beranda
              </WrapperNavigate>
              <WrapperNavigate
                path="/pelatihan"
                matchPattern={['/pelatihan', '/detail/pelatihan']}
                isMenu={true}
              >
                Pelatihan
              </WrapperNavigate>
              <WrapperNavigate
                path="/klinik-pengetahuan"
                matchPattern="/klinik-pengetahuan"
                isMenu={true}
              >
                Klinik Pengetahuan
              </WrapperNavigate>

              {/* Menu Kontributor dengan Dropdown */}
              <Menu>
                <MenuButton
                  as={Text}
                  fontSize="md"
                  display="inline-block"
                  _hover={{
                    '::after': {
                      content: `''`,
                      display: 'block',
                      width: '100%',
                      height: '2px',
                      background: 'green.700',
                      transition: 'width 0.2s',
                    },
                  }}
                  _after={{
                    content: `''`,
                    display: 'block',
                    width: '0',
                    height: '2px',
                    background: 'green.700',
                  }}
                >
                  Berbagi Pengetahuan
                </MenuButton>
                <MenuList>
                  <MenuItem
                    _hover={{ bg: 'green.100', color: 'green.800' }}
                    onClick={() => handleNavigate('/daftar-pengetahuan')}
                  >
                    Daftar Pengetahuan
                  </MenuItem>
                  <MenuItem
                    _hover={{ bg: 'green.100', color: 'green.800' }}
                    onClick={() => handleNavigate('/kontributor')}
                  >
                    Kontributor
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Flex>

          {/* Search Training */}
          <Flex className="gap-3">
            {locationPage === '/' && GetAuthData() === null && (
              <Flex position="relative">
                <Box
                  position="absolute"
                  insetY={0}
                  left={0}
                  pl={3}
                  display="flex"
                  alignItems="center"
                >
                  <Icon as={AiOutlineSearch} h={5} w={5} color="gray.500" />
                </Box>
                <form onSubmit={(e) => searchPelatihan(e)}>
                  <Input
                    type="text"
                    width="300px"
                    fontSize="md"
                    variant="outline"
                    borderColor="gray.300"
                    borderRadius="md"
                    _hover={{ borderColor: 'gray.500' }}
                    _focus={{
                      ring: '1',
                      ringColor: 'gray.500',
                      borderColor: 'gray.500',
                    }}
                    height={10}
                    pl={10}
                    placeholder="Cari Pelatihan"
                    onChange={(e) => setKeyword(e.target.value)}
                  />
                </form>
              </Flex>
            )}

            {/* Login Button & User Profile */}
            {GetAuthData() ? (
              <UserProfile />
            ) : (
              <Button
                type="button"
                color="white"
                bg="green.700"
                _hover={{ bg: 'green.800' }}
                _active={{ bg: 'green.800' }}
                fontSize="sm"
                px={4}
                rounded="md"
                onClick={() => handleNavigate('/login')}
                display={locationPage === '/login' ? 'none' : 'block'}
              >
                Masuk
              </Button>
            )}
          </Flex>
        </Flex>
      </Box>

      {/* small screen */}
      {GetAuthData() ? (
        <MenuBottomNavbar />
      ) : (
        <Box
          display={{ base: 'block', md: 'none' }}
          py={2}
          h={showMenu ? '100vh' : 'auto'}
        >
          <Flex
            justifyContent="space-between"
            alignItems="center"
            py={2}
            px={8}
          >
            <WrapperNavigate path="/" matchPattern="/">
              <LogoPintar style={{ width: '5rem' }} />
            </WrapperNavigate>
            <Icon
              as={showMenu ? IoMdClose : GiHamburgerMenu}
              boxSize={6}
              onClick={() => setShowMenu(!showMenu)}
              _hover={{ cursor: 'pointer' }}
            />
          </Flex>
          {showMenu ? (
            <Box
              py={2}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              h="full"
            >
              <Box>
                <WrapperNavigate path="/" matchPattern="/">
                  <Text
                    color="black"
                    fontSize="md"
                    _hover={{ bg: 'green.700', color: 'white' }}
                    py={4}
                    px={8}
                    w="full"
                  >
                    Beranda
                  </Text>
                </WrapperNavigate>
                <WrapperNavigate
                  path="/pelatihan"
                  matchPattern={['/pelatihan', '/detail/pelatihan']}
                >
                  <Text
                    color="black"
                    fontSize="md"
                    _hover={{ bg: 'green.700', color: 'white' }}
                    py={4}
                    px={8}
                    w="full"
                  >
                    Pelatihan
                  </Text>
                </WrapperNavigate>
                <WrapperNavigate
                  path="/klinik-pengetahuan"
                  matchPattern="/klinik-pengetahuan"
                >
                  <Text
                    color="black"
                    fontSize="md"
                    _hover={{ bg: 'green.700', color: 'white' }}
                    py={4}
                    px={8}
                    w="full"
                  >
                    Klinik Pengetahuan
                  </Text>
                </WrapperNavigate>

                {/* Menu Kontributor dengan Dropdown di layar kecil */}
                <Menu>
                  <MenuButton
                    as={Text}
                    color="black"
                    fontSize="md"
                    _hover={{ bg: 'green.700', color: 'white' }}
                    py={4}
                    px={8}
                    w="full"
                  >
                    Berbagi Pengetahuan
                  </MenuButton>
                  <MenuList>
                    <MenuItem
                      onClick={() => handleNavigate('/daftar-pengetahuan')}
                    >
                      Daftar Pengetahuan
                    </MenuItem>
                    <MenuItem onClick={() => handleNavigate('/kontributor')}>
                      Kontributor
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Box>
              {/* Konten lainnya */}
              <Box w="full" px={8} mb={20}>
                <Divider mb={12} />
                <Box my={4}>
                  <Text fontSize="xl" fontWeight="semibold">
                    Sudah Punya Akun?
                  </Text>
                  <Text fontSize="xs" mt={2}>
                    Masuk atau daftar untuk akses ratusan video pelatihan
                  </Text>
                </Box>
                <Button
                  w="full"
                  color="white"
                  bg="green.700"
                  _hover={{ bg: 'green.800' }}
                  _active={{ bg: 'green.800' }}
                  variant="outline"
                  onClick={() => handleNavigate('/login')}
                >
                  Masuk
                </Button>
                <Box position="relative" py="10">
                  <Divider />
                  <AbsoluteCenter bg="white" px="4">
                    Atau
                  </AbsoluteCenter>
                </Box>
                <Button
                  w="full"
                  color="green.700"
                  bg="white"
                  borderColor="green.700"
                  _hover={{ bg: 'green.800', color: 'white' }}
                  _active={{ bg: 'green.800', color: 'white' }}
                  variant="outline"
                  onClick={() => handleNavigate('/register')}
                >
                  Daftar
                </Button>
              </Box>
            </Box>
          ) : null}
        </Box>
      )}
    </>
  );
};

export default NewNavbar;
